$(function() {
    $('.toggle a').on('click', function(e){
        e.preventDefault();
        $('.toggle a').removeClass('active');
        $(this).addClass('active');
        var el = $(this).attr('data-toggle');
        if( el === 'all'){
            $('.tableComponent').removeClass('tableHidden');
        }else{
            $('.tableComponent').each(function () {
                $(this).attr('data-toggle') === el ? $(this).removeClass('tableHidden') : $(this).addClass('tableHidden');
            });
        }
    });
});

